import React, { ReactNode } from 'react';
import styled from 'styled-components';
import Header from './layout/Header';
import Footer from './layout/Footer';
import StickyDownloadBar from './StickyDownloadBar';

interface LayoutProps {
  children: ReactNode;
}

const LayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const MainContent = styled.main`
  flex: 1;
  width: 100%;
`;

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <LayoutWrapper>
      <Header />
      <MainContent>
        {children}
      </MainContent>
      <Footer />
      <StickyDownloadBar />
    </LayoutWrapper>
  );
};

export default Layout; 